
import { Component, Vue, Prop } from 'vue-property-decorator'
import { LeakStatus } from '@/api/types'
import { GetLeakStatusColor, GetLeakStatusIcon } from '@/utils/statusUi'

@Component({
  name: 'LeakStatusTag'
})
export default class LeakStatusTag extends Vue {
  @Prop({ required: true }) private status!: number
  @Prop({ default: 'medium' }) private size!: string
  @Prop({ default: true }) private showIcon!: boolean

  get statusType() {
    // 将颜色映射到 Element UI 的 tag 类型
    const colorToType: Record<string, string> = {
      '#909399': 'info',      // 灰色
      '#E6A23C': 'warning',   // 黄色
      '#409EFF': 'primary',   // 蓝色
      '#67C23A': 'success',   // 绿色
      '#F56C6C': 'danger'     // 红色
    }

    const color = GetLeakStatusColor(this.status)
    return colorToType[color] || 'info'
  }

  get statusIcon() {
    return GetLeakStatusIcon(this.status)
  }

  get statusText() {
    const statusMap: Record<number, string> = {
      [LeakStatus.Unreported]: '未上报',
      [LeakStatus.NeedAssignRepairDept]: '待分配',
      [LeakStatus.NeedAssignRepairUser]: '待认领',
      [LeakStatus.Repairing]: '维修中',
      [LeakStatus.Repaired]: '完成维修',
      [LeakStatus.CantRepair]: '无法维修',
      [LeakStatus.NoNeedRepair]: '无需维修'
    }
    return statusMap[this.status]
  }
}
